// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 96) return "vendors-fa6d31e2ef3695d2de89.js";
	// return url for filenames based on template
	return "" + ({"644":"__federation_expose_plan_list","943":"__federation_expose_handlers"}[chunkId] || chunkId) + "-" + {"474":"8a6aaae6b10bcf677bc8","644":"8f41f4ae0dc94a4bfa71","943":"9a58d2cc3aea49ad6bcb"}[chunkId] + ".js";
};